import { render, staticRenderFns } from "./CategoryProductGrid.vue?vue&type=template&id=433dad8f&scoped=true&"
import script from "./CategoryProductGrid.vue?vue&type=script&lang=ts&"
export * from "./CategoryProductGrid.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryProductGrid.vue?vue&type=style&index=0&id=433dad8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433dad8f",
  null
  
)

export default component.exports